module.exports = __webpack_public_path__ + "img/football_460.15c5bec3.png";